import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
var blue = {
  lightest: "#E3E8FA",
  lighter: "#B4C3F3",
  light: "#859EEC",
  base: "#456AE2",
  dark: "#334FA9",
  darker: "#192E73",
  darkest: "#0B163B"
};
var green = {
  lightest: "#D9ECE8",
  lighter: "#99CEC1",
  light: "#59AF9B",
  base: "#008566",
  dark: "#00634C",
  darker: "#004232",
  darkest: "#002119"
};
var white = "#FFFFFF";
var black = "#21201F";
var gray = {
  lightest: white,
  lighter: "#FBF9F7",
  light: "#F0EEEB",
  base: "#D8D4CF",
  dark: "#A09C96",
  darker: "#514F4B",
  darkest: black
};
var orange = {
  lightest: "#FFEEDE",
  lighter: "#FFD2A8",
  light: "#FFB671",
  base: "#FF8F26",
  dark: "#BF6B1C",
  darker: "#834306",
  darkest: "#432103"
};
var pink = {
  lightest: "#FEE8EC",
  lighter: "#FDC1CD",
  light: "#FB9BAD",
  base: "#FA6682",
  dark: "#BB4C61",
  darker: "#7C2637",
  darkest: "#3E121A"
};
var purple = {
  lightest: "#F6E8F9",
  lighter: "#E8C2EF",
  light: "#DA9CE6",
  base: "#C767D9",
  dark: "#954DA2",
  darker: "#6C2E78",
  darkest: "#38153F"
};
var yellow = {
  lightest: "#FFF7DE",
  lighter: "#FFEAA8",
  light: "#FFDD71",
  base: "#FFCB26",
  dark: "#BF981C",
  darker: "#866807",
  darkest: "#4B3801"
};

function determineButtonColors(props) {
  var backgroundColor = void 0,
      color = void 0,
      borderColor = void 0;

  switch (props.buttonStyle) {
    case "primary-dark":
    default:
      borderColor = black;
      backgroundColor = gray.darker;
      color = white;
      break;

    case "primary-light":
      borderColor = black;
      backgroundColor = gray.lighter;
      color = black;
      break;

    case "secondary-dark":
      borderColor = black;
      backgroundColor = gray.lighter;
      color = black;
      break;

    case "secondary-light":
      borderColor = white;
      backgroundColor = "transparent";
      color = white;
      break;
  }

  return {
    backgroundColor: backgroundColor,
    color: color,
    borderColor: borderColor
  };
}

function determineButtonSize(props) {
  var height = void 0,
      fontSize = void 0,
      minWidth = void 0,
      lineHeight = void 0,
      letterSpacing = void 0;

  switch (props.buttonSize) {
    case "sm":
      height = "32px";
      fontSize = "12px";
      lineHeight = "16px";
      letterSpacing = "0.85px";
      minWidth = "176px";
      break;

    case "md":
      height = "40px";
      fontSize = "12px";
      lineHeight = "16px";
      letterSpacing = "0.85px";
      minWidth = "176px";
      break;

    case "lg":
    default:
      height = "48px";
      fontSize = "14px";
      lineHeight = "20px";
      letterSpacing = "1px";
      minWidth = "232px";
      break;

    case "xl":
      height = "56px";
      fontSize = "16px";
      lineHeight = "24px";
      letterSpacing = "1.15px";
      minWidth = "232px";
      break;
  }

  return {
    height: height,
    fontSize: fontSize,
    minWidth: minWidth,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing
  };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(["\n    /* Generic Styles */\n    border-width: 2px;\n    border-style: solid;\n    font-weight: bold;\n    letter-spacing: 1px;\n    line-height: 18px;\n    text-align: center;\n    margin: 0;\n    box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.25);\n    cursor: pointer;\n    \n    /* See if Logan wants the transition or not */\n    transition: transform .05s ease-in-out ,box-shadow .05s ease-in-out;\n\n    /* Color styles */\n    ", "\n\n    /* Sizes */\n    ", "\n\n    /* Uppercase */\n    text-transform: ", ";\n\n    :hover:enabled {\n        transform: translate(2px, 2px);\n        box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.25);\n\n        ", "\n    }\n\n    :active:enabled {\n        transform: translate(4px, 4px);\n        box-shadow: none;\n    }\n\n    :focus {\n        outline: 1px solid ", "\n    }\n\n    :disabled {\n        cursor: not-allowed;\n        opacity: 40%;\n        box-shadow: none;\n        ", "\n    }\n"], ["\n    /* Generic Styles */\n    border-width: 2px;\n    border-style: solid;\n    font-weight: bold;\n    letter-spacing: 1px;\n    line-height: 18px;\n    text-align: center;\n    margin: 0;\n    box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.25);\n    cursor: pointer;\n    \n    /* See if Logan wants the transition or not */\n    transition: transform .05s ease-in-out ,box-shadow .05s ease-in-out;\n\n    /* Color styles */\n    ", "\n\n    /* Sizes */\n    ", "\n\n    /* Uppercase */\n    text-transform: ", ";\n\n    :hover:enabled {\n        transform: translate(2px, 2px);\n        box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.25);\n\n        ", "\n    }\n\n    :active:enabled {\n        transform: translate(4px, 4px);\n        box-shadow: none;\n    }\n\n    :focus {\n        outline: 1px solid ", "\n    }\n\n    :disabled {\n        cursor: not-allowed;\n        opacity: 40%;\n        box-shadow: none;\n        ", "\n    }\n"]),
    _templateObject2 = taggedTemplateLiteral(["\n            color: ", ";\n            background-color: ", ";\n            border-color: ", ";\n        "], ["\n            color: ", ";\n            background-color: ", ";\n            border-color: ", ";\n        "]),
    _templateObject3 = taggedTemplateLiteral(["\n            height: ", ";\n            font-size: ", ";\n            min-width: ", ";\n            line-height: ", ";\n            letter-spacing: ", ";\n        "], ["\n            height: ", ";\n            font-size: ", ";\n            min-width: ", ";\n            line-height: ", ";\n            letter-spacing: ", ";\n        "]),
    _templateObject4 = taggedTemplateLiteral(["\n                background-color: transparent;\n            "], ["\n                background-color: transparent;\n            "]),
    _templateObject5 = taggedTemplateLiteral(["\n                background-color: ", ";\n            "], ["\n                background-color: ", ";\n            "]);

var StyledButton = styled.button(_templateObject, function (props) {
  var _determineButtonColor = determineButtonColors(props),
      color = _determineButtonColor.color,
      backgroundColor = _determineButtonColor.backgroundColor,
      borderColor = _determineButtonColor.borderColor;

  return css(_templateObject2, color, backgroundColor, borderColor);
}, function (props) {
  var _determineButtonSize = determineButtonSize(props),
      height = _determineButtonSize.height,
      fontSize = _determineButtonSize.fontSize,
      minWidth = _determineButtonSize.minWidth,
      lineHeight = _determineButtonSize.lineHeight,
      letterSpacing = _determineButtonSize.letterSpacing;

  return css(_templateObject3, height, fontSize, minWidth, lineHeight, letterSpacing);
}, function (props) {
  return props.uppercase && "uppercase";
}, function (props) {
  return props.buttonStyle.startsWith("secondary") && css(_templateObject4);
}, blue.base, function (props) {
  return props.buttonStyle === "primary-dark" && css(_templateObject5, black);
});
StyledButton.propTypes = {
  buttonStyle: PropTypes.oneOf(["primary-dark", "primary-light", "secondary-dark", "secondary-light"]),
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  uppercase: PropTypes.bool,
  inverse: PropTypes.bool
};
StyledButton.defaultProps = {
  buttonStyle: "primary-dark",
  size: "md",
  uppercase: false,
  inverse: false
};

var _templateObject$1 = taggedTemplateLiteral(["\n    height: 20px;\n    width: 20px;\n    transition: transform 0.3s ease-in-out;\n    transform: ", ";\n"], ["\n    height: 20px;\n    width: 20px;\n    transition: transform 0.3s ease-in-out;\n    transform: ", ";\n"]);

var Svg = styled.svg(_templateObject$1, function (props) {
  return props.open ? "rotate(0)" : "rotate(-90deg)";
});

var Arrow = function Arrow(_ref) {
  var open = _ref.open;
  return React.createElement(Svg, {
    open: open,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
  }));
};

var _templateObject$2 = taggedTemplateLiteral(["\n    /* border-bottom: 1px solid ", ";\n    cursor: pointer;\n\n    &:first-child {\n        border-top: 1px solid ", ";\n    } */\n"], ["\n    /* border-bottom: 1px solid ", ";\n    cursor: pointer;\n\n    &:first-child {\n        border-top: 1px solid ", ";\n    } */\n"]),
    _templateObject2$1 = taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: var(--blue);\n"], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: var(--blue);\n"]),
    _templateObject3$1 = taggedTemplateLiteral(["\n    font-size: 1em;\n    line-height: 28px;\n    font-weight: 500;\n    margin: 24px 0;\n"], ["\n    font-size: 1em;\n    line-height: 28px;\n    font-weight: 500;\n    margin: 24px 0;\n"]),
    _templateObject4$1 = taggedTemplateLiteral(["\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out;\n"], ["\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out;\n"]);

var Container = styled.div(_templateObject$2, gray.base, gray.light);
var Title = styled.div(_templateObject2$1);
var H5 = styled.h5(_templateObject3$1);
var Body = styled.div(_templateObject4$1);

var Accordion = function Accordion(_ref) {
  var title = _ref.title,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ["title", "children"]);

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState("0px"),
      _useState4 = slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var accordionContent = useRef(null);

  var toggleAccordion = function toggleAccordion() {
    setOpen(!open);
    setHeight(open ? "0px" : accordionContent.current.scrollHeight + "px");
  };

  return React.createElement(Container, _extends({
    onClick: toggleAccordion
  }, rest), React.createElement(Title, null, React.createElement(H5, {
    open: open
  }, title), React.createElement(Arrow, {
    open: open
  })), React.createElement(Body, {
    ref: accordionContent,
    style: {
      maxHeight: height
    }
  }, children));
};

var _templateObject$3 = taggedTemplateLiteral(["\n    & > div {\n        border-bottom: 1px solid ", ";\n        cursor: pointer;\n    }\n\n    & > div:first-child {\n        border-top: 1px solid ", ";\n    }\n"], ["\n    & > div {\n        border-bottom: 1px solid ", ";\n        cursor: pointer;\n    }\n\n    & > div:first-child {\n        border-top: 1px solid ", ";\n    }\n"]);

var Group = styled.section(_templateObject$3, gray.base, gray.base);

function AccordionGroup(_ref) {
  var children = _ref.children,
      rest = objectWithoutProperties(_ref, ["children"]);
  return React.createElement(Group, rest, children);
}

export { StyledButton as Button, Accordion, AccordionGroup, blue, green, gray, white, black, orange, pink, purple, yellow };